module.exports = __webpack_public_path__ + "img/50.73d31d5b.jpg";